import React from "react";
import "./ChatWindow.css";

/** Segmented Chat | Talk toggle for the chat header. */
export default function ModeSwitch({ mode, onChange }) {
  return (
    <div className="mode-switch" role="tablist" aria-label="Chat or voice mode">
      <button
        type="button"
        role="tab"
        aria-selected={mode === "chat"}
        className={mode === "chat" ? "active" : ""}
        onClick={() => onChange("chat")}
      >
        Chat
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === "voice"}
        className={mode === "voice" ? "active" : ""}
        onClick={() => onChange("voice")}
      >
        Talk
      </button>
    </div>
  );
}
